import React from 'react';
import { Check, X } from 'lucide-react';

export function evaluatePassword(pw = '') {
  const rules = [
    { id: 'length', label: 'At least 8 characters', test: (p) => p.length >= 8 },
    { id: 'upper', label: 'One uppercase letter (A-Z)', test: (p) => /[A-Z]/.test(p) },
    { id: 'lower', label: 'One lowercase letter (a-z)', test: (p) => /[a-z]/.test(p) },
    { id: 'number', label: 'One number (0-9)', test: (p) => /\d/.test(p) },
    { id: 'symbol', label: 'One symbol (!@#$%…)', test: (p) => /[^A-Za-z0-9]/.test(p) },
  ];
  const passed = rules.map((r) => ({ ...r, ok: r.test(pw) }));
  const score = passed.filter((r) => r.ok).length;
  const label = ['Too weak', 'Weak', 'Okay', 'Good', 'Strong', 'Excellent'][score];
  return { score, label, rules: passed, isStrong: score >= 4 };
}

export default function PasswordStrengthMeter({ password = '', showChecklist = true, testId = 'password-strength' }) {
  if (!password) return null;
  const { score, label, rules } = evaluatePassword(password);
  const bars = [0, 1, 2, 3, 4];
  const colors = ['bg-red-500', 'bg-red-500', 'bg-amber-500', 'bg-amber-500', 'bg-emerald-500', 'bg-emerald-600'];
  const textColor = score <= 1 ? 'text-red-600' : score <= 3 ? 'text-amber-600' : 'text-emerald-700';

  return (
    <div className="mt-2" data-testid={testId}>
      <div className="flex items-center gap-1.5 mb-1.5">
        {bars.map((i) => (
          <div
            key={i}
            className={`h-1.5 flex-1 rounded-full transition-colors ${i < score ? colors[score] : 'bg-[#E2E8F0]'}`}
            data-testid={`${testId}-bar-${i}`}
          />
        ))}
      </div>
      <div className={`text-xs font-bold ${textColor}`} data-testid={`${testId}-label`}>{label}</div>
      {showChecklist && (
        <ul className="mt-2 space-y-1" data-testid={`${testId}-checklist`}>
          {rules.map((r) => (
            <li key={r.id} className="flex items-center gap-2 text-xs" data-testid={`${testId}-rule-${r.id}`}>
              {r.ok ? <Check size={12} className="text-emerald-600" /> : <X size={12} className="text-[#94A3B8]" />}
              <span className={r.ok ? 'text-emerald-700' : 'text-[#94A3B8]'}>{r.label}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
